import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section id="common-questions" aria-labelledby="faq-heading" className="w-full border-y border-kosin-line bg-kosin-mist" data-id="element-39" data-mp="1lb90yxa19gj2">
      <div className="mx-auto max-w-[960px] px-[18px] py-12 sm:px-6 lg:py-14" data-id="element-40" data-mp="1gdqt7a7r57cn">
          <h2 id="faq-heading" className="mb-8 text-center text-[28px] font-bold leading-tight text-kosin-charcoal lg:text-[36px]" data-id="element-41" data-mp="2e0pphjuj8da0">
            Common Questions
          </h2>

          <dl className="divide-y divide-kosin-line border-y border-kosin-line" data-id="element-42" data-mp="2418nbcehohis">
            {faqs.map((faq, i) => {
          const isOpen = open === i;
          return <div key={faq.question} data-id="element-43" data-mp="snd7s2joa6r1" data-mpi={i}>
                  <dt data-id="element-44" data-mp="soeksck913be">
                    <button type="button" className="group flex w-full items-start justify-between gap-4 py-5 text-left" aria-expanded={isOpen} aria-controls={`faq-answer-${i}`} onClick={() => setOpen(isOpen ? null : i)} data-id="element-45" data-mp="skqrneipuix7">
                      <span className="text-[17px] font-semibold text-kosin-charcoal transition-colors group-hover:text-kosin-red sm:text-[18px]" data-id="element-46" data-mp="fiysa0bzw46d">
                        {faq.question}
                      </span>
                      {isOpen ? <MinusIcon className="mt-1 h-5 w-5 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-47" data-mp="bi6hh2nh5r7z" /> : <PlusIcon className="mt-1 h-5 w-5 shrink-0 text-kosin-red" aria-hidden="true" data-id="element-48" data-mp="1s3o31cfyb94" />}
                    </button>
                  </dt>
                  <dd id={`faq-answer-${i}`} hidden={!isOpen} className="pb-6 text-[16px] leading-relaxed text-kosin-body sm:pr-10" data-id="element-49" data-mp="3nys7mbulb9lu">
                    {faq.answer}
                  </dd>
                </div>;
        })}
          </dl>
      </div>
    </section>;
}